import { render } from "./DsoRiderStepOne.vue?vue&type=template&id=24d2d842&scoped=true"
import script from "./DsoRiderStepOne.vue?vue&type=script&lang=js"
export * from "./DsoRiderStepOne.vue?vue&type=script&lang=js"

import "./DsoRiderStepOne.vue?vue&type=style&index=0&id=24d2d842&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24d2d842"]])

export default __exports__